<template lang="pug">
#services-tab
  b-table(
    :data="services"
    :current-page="pagination.page"
    :per-page="pagination.per"
    :total="pagination.total"
    @click="open"
    @dragstart="dragstart"
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
    @page-change="getPage"
    backend-pagination
    draggable
    hoverable
    paginated
  )
    template(slot-scope="props")
      b-table-column(width="25")
        b-icon.drag-icon.has-text-grey-light(icon="drag-vertical")
      b-table-column(label="Service") {{ props.row.title }}
      b-table-column(label="Date and Time")
        small
          span {{ props.row.frequency | serviceFrequency }} {{ props.row.weekday }}
          span {{ props.row.end_time ? ' from ' : ' at ' }}
          span {{ props.row.start_time | date('h:mm A') }}
          span(v-if="props.row.end_time") &ndash;{{ props.row.end_time | date('h:mm A') }}
      b-table-column(label="Ministry")
        small(v-if="props.row._embedded.ministry") {{ props.row._embedded.ministry.name }}
        small.has-text-grey-light(v-else) NA
      b-table-column(label="Age/Grade Range")
        small(v-if="props.row.age_range") {{ props.row.age_range }}
        small.has-text-grey-light(v-else) NA
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ServiceForm from '@/components/form/ServiceForm';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'services-tab',
  computed: {
    ...mapGetters({
      filters: getters.GET_MINISTRY_FILTERS,
      services: getters.GET_SERVICES,
      refresh: getters.GET_MINISTRY_REFRESH,
    }),
  },
  created() {
    this.getPage(1);
  },
  data() {
    return {
      dragging: null,
      settings: {
        loading: false,
      },
      pagination: {
        page: 1,
        per: 12,
        total: 0,
      },
    };
  },
  methods: {
    dragstart(payload) {
      this.dragging = payload.row;
      payload.event.dataTransfer.effectAllowed = 'copy';
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy';
      payload.event.target.closest('tr').classList.add('is-selected');
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.preventDefault();
    },
    async drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      this.$store.commit(mutations.INSERT_SERVICE, {
        index: payload.index,
        val: this.dragging,
      });
      const saveServices = [];
      this.services.forEach(service => saveServices.push(this.saveService(service)));
      await Promise.all(saveServices);
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: 'Sort order updated',
      });
    },
    async getPage(page) {
      this.settings.loading = true;
      this.pagination.page = page;
      const payload = {
        page,
        zoom: 'ministry',
      };
      if (this.filters.query) {
        payload.query = this.filters.query;
      }
      await this.$store.dispatch(actions.DO_GET_SERVICES, payload);
      setTimeout(() => {
        this.settings.loading = false;
        this.$store.commit(mutations.SET_MINISTRY_REFRESH, false);
      }, 250);
    },
    async open(service) {
      await this.$store.dispatch(actions.DO_GET_SERVICE, {
        id: service.id,
      });
      this.$buefy.modal.open({
        parent: this,
        component: ServiceForm,
        hasModalCard: true,
      });
    },
    async saveService(service) {
      const index = _.findIndex(this.services, { id: service.id });
      if (index >= 0) {
        await this.$store.dispatch(actions.DO_UPDATE_SERVICE, {
          id: service.id,
          sort_order: index,
        });
      }
    },
  },
  watch: {
    refresh(val) {
      if (val) this.getPage(1);
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/ServicesTab.vue